import { useNavigate } from "react-router";
import { useMultiStepFormStore } from "../../../store/multiStepFormStore";
import { ALL_INSTRUCTIONS } from "../../../utils/constants";

const BuilderDashboard = () => {
    const navigate = useNavigate();
    const { drafts, removeDraftByDraftId } = useMultiStepFormStore();

    const getAsOfDate = (draft) => {
        const asOfDate = draft.asOfDate;
        if (asOfDate) {
            if (typeof asOfDate === 'string') {
                return asOfDate.substring(0, 10);
            } else if (asOfDate instanceof Date) {
                return asOfDate.toLocaleString?.("en-US", { timeZone: "America/New_York", year: "numeric", month: "2-digit", day: "2-digit" })?.substring(0, 10);
            }
        }
        return '';
    };

    return (
        <div className="container" style={{ position: "relative" }}>
            <p className="title"> Select a draft </p>
            <p className="sub-title">Draft are saved on your local system for now. Once they are deleted they will be gone. </p>
            <div className="stickies" style={{ padding: "1rem 0rem", overflowY: 'scroll' }}>
                <div
                    className="sticky"
                    style={{ display: "grid", placeItems: "center", backgroundColor: 'var(--lightestGrey)', cursor: 'not-allowed' }}
                    onClick={() => {
                        const draftId = crypto.randomUUID();
                        //    addDraft({ activeStep: 1, draftId, action: "Create" });
                        //    navigate(`/config/plan-builder/${draftId}`);
                    }}
                >
                    <div style={{ textAlign: 'center', color: 'var(--lighterGrey)' }}>
                        <p style={{ fontWeight: 600, fontSize: "1.2rem", }}>Add</p>
                        <p >Disabled until HRP issue is fixed</p>
                    </div>

                </div>

                {drafts
                    ?.sort((a, b) => b.updatedAt?.localeCompare(a.updatedAt))
                    .map((draft) => (
                        <div className="sticky" key={draft.draftId}>
                            <div className="sticky-header">
                                <h3>{draft.draftId}</h3>
                                <button
                                    className="sticky-delete"
                                    onClick={() => {
                                        removeDraftByDraftId(draft.draftId);
                                     }}
                                >&times;</button>
                            </div>
                            <div
                                className="sticky-body"
                                onClick={() => navigate(`/config/plan-builder/${encodeURIComponent(draft.draftId)}`)}
                            >
                                <div className="sticky-section">
                                    <p className="label">Version Date</p>
                                    <p className="value">{getAsOfDate(draft)}</p>
                                </div>
                                <div className="sticky-section">
                                    <p className="label">History Fact Key</p>
                                    <p className="value">{draft.benefitPlanHistoryFactKey}</p>
                                </div>
                                <div className="sticky-section">
                                    <p className="label">Account</p>
                                    <p className="value">{draft.account?.value}</p>
                                </div>
                                <div className="sticky-section">
                                    <p className="label">Name</p>
                                    <p className="value">{draft.benefitPlanName}</p>
                                </div>
                                <div className="sticky-section">
                                    <p className="label">Description</p>
                                    <p className="value">{draft.benefitPlanDesc}</p>
                                </div>
                                <div className="sticky-section">
                                    <p className="label">Last Updated</p>
                                    <p className="value">{draft.updatedAt}</p>
                                </div>
                                <div className="sticky-section">
                                    <p className="label">Active Step</p>
                                    <p className="value">{draft.activeStep} - {ALL_INSTRUCTIONS.find((ins) => ins.step === draft.activeStep)?.instructions}</p>
                                </div>
                            </div>
                        </div>
                    ))}
            </div>
        </div>
    )
}

export default BuilderDashboard